define([
    "dojo/_base/declare",
    "csi/heading/Ref",
	"csi/xml"
], function(declare,Ref,xml) {

    return declare(Ref, {
    	_getRenderAction: function() {
    		// no render action
    	},

		reserveContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: apply any renderer-specific changes to context before use
			var	thisNode = ctx.getNode();
			var nodeToPush = thisNode;

			while (thisNode) {
				if (!xml.isEmptyURL(thisNode.MaterialSchedule)) {
					nodeToPush = thisNode;
					break;
				} else {
					thisNode = ctx.cache.getNode(thisNode.__Parent__); // keep traversing
				}
			}

			ctx.pushParams().setNode(nodeToPush);
			this.inherited(arguments);
		},

		releaseContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: pop context applied above
			ctx.pop();
			this.inherited(arguments);
		}
    });
});